import LocalStorage from '../../../services/storage/LocalStorage';
import { createBirthDetails } from '../../../models/BirthDetails';

/**
 * Birth Details Collector
 * Collects birth details in the background (not displayed in UI)
 * For prototype, uses simulated/default data
 */
export class BirthDetailsCollector {
  /**
   * Collect birth details (simulated for prototype)
   * In production, this would collect actual user input
   */
  static collect(): void {
    // For prototype, create default birth details
    // In production, this would be collected from user input
    const birthDetails = createBirthDetails(
      new Date(1990, 0, 1), // Default date
      undefined, // No time for prototype
      {
        city: 'Unknown',
        country: 'Unknown',
      }
    );

    // Store birth details (encrypted in production)
    LocalStorage.setItem(LocalStorage.getKeys().BIRTH_DETAILS, birthDetails);
  }
}

export default BirthDetailsCollector;
